import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import ErrorText from "~/components/Form/ErrorText"

import WinItButton from "~/components/WinItButton"
import Lock from "~/components/svg/Lock"

const ButtonContainer = styled.div`
  width: 270px;
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
`

const ButtonContent = styled.div`
  display: flex;
  flex-grow: 0;
  flex-shrink: 0;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`

const SubText = styled.div`
  user-select: none;
  font-size: 1rem;
  margin-top: 10px;
  color: ${props => props.theme.colors.text.label};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
`

const IconContainer = styled.div`
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
`

const LockButton = ({
  disabled,
  onClick,
  color,
  text,
  subText,
  lockColor,
  error
}) => {
  const setLockColor = lockColor || "#FFFFFF"
  return (
    <ButtonContainer>
      <ErrorText fontSize="16px" error={error} />
      <WinItButton
        disabled={disabled}
        fontSize="16px"
        width="100%"
        padding="20px"
        onClick={onClick}
        color={color}
      >
        <ButtonContent>
          <IconContainer>
            <Lock color={setLockColor} />
          </IconContainer>
          {text}
        </ButtonContent>
      </WinItButton>
      {subText ? <SubText>{subText}</SubText> : null}
    </ButtonContainer>
  )
}

LockButton.defaultProps = {
  disabled: false
}

LockButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
}

export default LockButton
